module.exports = __webpack_public_path__ + "img/4.80df2506.png";